import React, { useState, useContext, useEffect, useMemo } from "react";

import ApiService from "./ApiService";
import { InputDropDowList2 as InputDropDowList, InputFile, PageControl, TabSheet } from "../../../components";
import { Button, Grid } from "@material-ui/core";
import { AppContext } from "../../../App";
import ArquivosSaidas, { ValidadeArquivosSaidas } from "./tipos/ArquivosSaidas";
import ArquivosRelatorioCaixa, { ValidadeArquivosRelatorioCaixa } from "./tipos/ArquivosRelatorioCaixa";
import { AppOptionsContext } from "../../../components/main/main";
import Variables from "../../../components/variables";
import ArquivosExtratoAplicacao, { ValidadeArquivosExtratoAplicacao } from "./tipos/ArquivosExtratoAplicacao";
import ApiTypes from "../../../api/system/types/ApiTypes";
import ToolsApi from "../../../api/system/tools";
import FilesConvertSiengiTotvs, { FilesConvertSiengiTotvsValidade } from "./tipos/FilesConvertSiengiTotvs";

const MENU = "M70-0210";
const ATTR_DEFAULT = { branch: {}, controlling_area: {}, chart_account: {} };

export default function CustomFilesTools() {
    const { setLoading, showMessageError } = useContext(AppContext);
    const { setOptions, setTitle } = useContext(AppOptionsContext);

    const [tabIndex, setTabIndex] = useState(0);
    const [typeFile, setTypeFile] = useState(1);
    const [atributos, setAtributos] = useState(ATTR_DEFAULT);
    const [files, setFiles] = useState([]);
    const [filesTypes, setFilesTypes] = useState([]);

    const onClearData = () => {
        setFiles([]);
        setAtributos(ATTR_DEFAULT);
    };

    const onLoadFiles = async (e) => {
        setFiles(Array.from(e.target.files));
    };

    const onLoadVariables = (menu, values) => {
        setAtributos({ ...ATTR_DEFAULT, ...values });
    };

    const onExport = async (attr) => {
        let result = {
            status: true,
        };

        let fileNameExport = files[0].name;

        switch (typeFile) {
            case 3:
                result = ValidadeArquivosSaidas(attr);
                fileNameExport = `ArquivoSaida-${attr?.branch?.document}.zip`;
                break;
            case 4:
                result = ValidadeArquivosRelatorioCaixa(attr);
                fileNameExport = `RelatorioCaixa-${attr?.branch?.document}.txt`;
                break;
            case 5:
                result = ValidadeArquivosExtratoAplicacao(attr);
                fileNameExport = `ExtratoAplicacao-${attr?.branch?.document}.txt`;
                break;
            case 6:
                result = FilesConvertSiengiTotvsValidade(attr);
                fileNameExport = `SiengeTOTVS-convertido.txt`;
                break;
            default:
                fileNameExport = fileNameExport.substr(0, fileNameExport.lastIndexOf(".")) + "-corrigido.xlsx";
                break;
        }

        if (!result.status) {
            showMessageError(result.message);
            return;
        }

        setLoading(true);
        try {
            const formData = new FormData();
            files.forEach((rec) => {
                formData.append(rec.name, rec, rec.name);
            });

            if (curTypeFile.source) {
                const response = await ToolsApi().anyFiles(curTypeFile.source, formData, fileNameExport, result.data);
                if (!response.status) {
                    showMessageError(response.message);
                }
            } else {
                const response = await ApiService.execute(typeFile, formData, fileNameExport, result.data);
                if (!response.status) {
                    showMessageError(response.message);
                }
            }
        } finally {
            setLoading(false);
        }
    };

    const curTypeFile = useMemo(() => {
        return filesTypes.find((rec) => rec.value === typeFile);
    }, [typeFile]);

    useEffect(() => {
        setTitle("Arquivos Diversos");

        // Types
        ApiTypes()
            .apiDefault.findAll({ entity: "tools", field: "$files" })
            .then((rec) => {
                setFilesTypes(rec.data[0].values);
            });

        return () => {
            setOptions(null);
        };
    }, []);

    useEffect(() => {
        if (tabIndex === 0) {
            setOptions(
                <>
                    <InputFile
                        style={{ float: "left", marginTop: "5px", marginBottom: "5px", marginRight: "5px" }}
                        color="primary"
                        multiple={false}
                        onFileSelect={(e) => onLoadFiles(e)}
                        fileExtension={curTypeFile?.fileExtension || ".xlsx"}
                        label={`Importar Arquivos`}
                    />
                    <Button
                        size="small"
                        style={{ float: "left", marginTop: "5px", marginBottom: "5px", marginRight: "5px" }}
                        variant="contained"
                        color="secundary"
                        onClick={() => onExport(atributos)}
                        disabled={!files.length}
                    >
                        Processar arquivo
                    </Button>
                    <Button
                        size="small"
                        style={{ float: "left", marginTop: "5px", marginBottom: "5px", marginRight: "5px" }}
                        variant="contained"
                        color="secondary"
                        onClick={() => onClearData()}
                    >
                        Limpar Dados
                    </Button>
                </>
            );
        }
    }, [tabIndex, files, atributos, curTypeFile]);

    return (
        <>
            <Grid container spacing={1}>
                <Grid item xs={6} style={{ marginBottom: "5px" }}>
                    <InputDropDowList
                        label="Tipo"
                        value={typeFile}
                        onChangeValue={(e) => setTypeFile(Number(e.target?.value) || 1)}
                        defaultValue={1}
                        data={filesTypes}
                    />
                </Grid>
                {curTypeFile?.menu && (
                    <Grid item xs={6} style={{ marginBottom: "5px" }}>
                        <Variables menu={`${MENU}-${curTypeFile.menu}`} currentValues={atributos} onLoadVariables={onLoadVariables} />
                    </Grid>
                )}
            </Grid>
            {curTypeFile?.menu && (
                <Grid item xs={12}>
                    <PageControl tabindex={tabIndex} onchangetab={(index) => setTabIndex(index)}>
                        <TabSheet label="Dados">
                            {typeFile === 3 && <ArquivosSaidas atributos={atributos} setAtributos={setAtributos} />}
                            {typeFile === 4 && <ArquivosRelatorioCaixa atributos={atributos} setAtributos={setAtributos} />}
                            {typeFile === 5 && <ArquivosExtratoAplicacao attr={atributos} setAttr={setAtributos} />}
                            {typeFile === 6 && <FilesConvertSiengiTotvs attr={atributos} setAttr={setAtributos} />}
                        </TabSheet>
                    </PageControl>
                </Grid>
            )}
        </>
    );
}
